import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import NotImage from '../../../../components/notImage'
import { classes, UnitListUnitStyle } from './style'
import IconsDetails from '../../../../components/iconsDetails'
import Divider from '@mui/material/Divider'
import UnitFooter from '../../../../components/unitFooter'
import numeral from 'numeral'

// eslint-disable-next-line react/prop-types
const Body = ({ unit }) => {
  // eslint-disable-next-line react/prop-types
  const price = `$${numeral(unit.price).format('0,0.00')}`
  return (
    <div className={classes.toolBarContent}>
      <div>
        {/* eslint-disable-next-line react/prop-types */}
        <div style={{ display: 'flex' }}>
          <Typography variant="h5" fontWeight="bold" align="left" className={classes.bodyTitle}>
            {price}
          </Typography>
          <div style={{ borderLeft: 'solid 2px gray', marginLeft: '1rem', paddingLeft: '1rem' }}>
            <Typography variant="body1" align="left" fontWeight="bold" className={classes.bodyTitle}>
              {/* eslint-disable-next-line react/prop-types */}
              {unit.countyName}
            </Typography>
            <Typography variant="body2" align="left" fontWeight="medium" className={classes.bodyTitle}>
              {/* eslint-disable-next-line react/prop-types */}
              {unit.buildingAddress}, {unit.stateName}
            </Typography>
          </div>
        </div>
        <br/>
        <Divider />
        <IconsDetails unit={unit}/>
        <Divider />
        <br/>
      </div>
      {/* eslint-disable-next-line react/prop-types */}
      <Link to={'/viewer/' + unit.buildingID + '/unit/' + unit.id} style={{ textDecoration: 'none' }}>
        {/* eslint-disable-next-line react/prop-types */}
        <Button variant="outlined" disabled={!unit.available}>View 3D Model</Button>
      </Link>
    </div>
  )
}

// eslint-disable-next-line react/prop-types
const UnitDetails = ({ unit }) => {
  return (
        <UnitListUnitStyle className={classes.root}>
            <Body unit={unit}/>
            <UnitFooter unit={unit}/>
        </UnitListUnitStyle>
  )
}
// eslint-disable-next-line react/prop-types
const Head = ({ unit }) => {
  // eslint-disable-next-line react/prop-types
  return unit.image
    // eslint-disable-next-line react/prop-types
    ? <img src={unit.image} style={{
      width: 400,
      objectFit: 'cover'
    }}/>
    : <NotImage/>
}

// eslint-disable-next-line react/prop-types
const Unit = ({ unit }) => {
  return (
        <>
            <Head unit={unit}/>
            <UnitDetails unit={unit}/>
        </>
  )
}

export default Unit
